/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  BackHandler,
  Platform,
} from 'react-native';
import {
  useEffect,
} from 'react';

export default function useBackButton(onBack) { // @TODO: a bunch of other components should be using this as well
  useEffect(() => {
    if (Platform.OS === 'web') {
      return () => {};
    }

    const backHandler = BackHandler.addEventListener('hardwareBackPress', onBack);

    return () => {
      backHandler.remove();
    };
  }, [onBack]);
}
